import React from "react";
import { Alert, Box, Button, SpaceBetween, Spinner } from "@cloudscape-design/components";
import { useAuth, redirectToLogin } from "./useAuth";
import { DashboardDevTokenPrompt } from "./DashboardDevTokenPrompt";

export type DashboardAuthRequiredProps = { children: React.ReactNode };

export function DashboardAuthRequired({ children }: DashboardAuthRequiredProps) {
  const { isAuthenticated, user, logout } = useAuth();

  if (!isAuthenticated) {
    if (import.meta.env.DEV) {
      return <DashboardDevTokenPrompt />;
    }
    redirectToLogin();
    return (
      <div className="flex justify-center items-center h-screen">
        <Spinner size="large" />
      </div>
    );
  }

  // Authenticated but not an internal user — show a clear forbidden message
  // rather than silently rendering the dashboard. Backend admin routes also
  // enforce this via Depends(require_internal); this gate is defense-in-depth
  // plus a better UX than a stream of 403s.
  if (user && user.user_type !== "internal") {
    return (
      <Box padding="xxl" textAlign="center">
        <SpaceBetween size="m">
          <Alert type="error" header="Dashboard access denied">
            The internal dashboard is only available to authorized users.
            You're signed in as {user.email}.
          </Alert>
          <Button onClick={() => logout()}>Sign out</Button>
        </SpaceBetween>
      </Box>
    );
  }

  return <>{children}</>;
}
